import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { IViolation } from 'app/model/base/annotation';

import { sanitizeAndFormatString } from './string.util';
import { LoggerService } from 'app/logger/logger.service';
import { IValidationContext } from 'shell-models-lib';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

export async function validateAKVLinkedserviceReference(linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> {
    if (linkedservice != null && !linkedservice.fullyByJsonEditor) {
        if (referencedResource instanceof AzureKeyVault && referencedResource.storageLinkedService == null) {
            const logger = await getServiceInstance<LoggerService>(context.contextData, 'LoggerService');
            // akv invalid
            logger.log('Linkedservice validation', 'Kicked AKV referenced validation');
            return [
                {
                    message: () => sanitizeAndFormatString(stringResources.Error_InvalidLinkedserviceReferenced, linkedservice.name, 'Azure Key Vault linked service')
                }
            ];
        }
    }
    return undefined;
}

export async function validateNullLinkedserviceReference(linkedservice: LinkedService, referencedResource: LinkedService, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> {
    if (linkedservice != null && !linkedservice.fullyByJsonEditor) {
        if (referencedResource == null) {
            const logger = await getServiceInstance<LoggerService>(context.contextData, 'LoggerService');
            logger.log('Linkedservice validation', 'Kicked null linkedservice referenced validation');
            // referenced other ls invalid
            return [
                {
                    message: () => sanitizeAndFormatString(stringResources.Error_InvalidLinkedserviceReferenced, linkedservice.name, 'linked service')
                }
            ];
        }
    }
    return undefined;
}
